import clsx from "clsx";
import { DOC_SOURCE } from "constants/documents";
import { ReactComponent as VtFileIcon } from "icons/vt.svg";
import { bool, func } from "prop-types";

import classes from "./DocumentSource.module.scss";

const VtSourceCard = ({ isActive, onClick }) => {
  const onClickButton = (e) => {
    e.stopPropagation();
    onClick(DOC_SOURCE.VT_EDITOR);
  };

  return (
    <button
      className={clsx(classes.card, isActive && classes.active)}
      onClick={onClickButton}
    >
      <VtFileIcon />
      <h4>VisibleThread</h4>

      <p>Write inside VisibleThread using the VisibleThread Editor.</p>
    </button>
  );
};

VtSourceCard.propTypes = {
  isActive: bool,
  onClick: func.isRequired,
};

export default VtSourceCard;
